// export const BASE_URL =
//   process.env.NODE_ENV === 'develeopment' ? 'http://localhost:5000' : '';
export const BASE_URL = ''; 
export const USERS_URL = '/api/users';
export const LOANS_URL = '/api/loans';
export const PAYMENTS_URL = '/api/payments';
export const BORROWERS_URL = '/api/borrowers';





